import { Col, Row, Form, Input, Select, } from "antd";
import { useTranslation } from "react-i18next";
import CostumeUpload from "../UI/Upload/CostumeUpload";
import { useState } from "react";

import { Option } from "./Setting";
import { settingsType } from "./settingsType";
type ErrorsType = {
  email?: string | undefined;
};
type prop = {
  formatedCountry: Option[] | undefined;
  settings: settingsType | undefined
};
const Company = ({ formatedCountry, settings }: prop) => {
  const [t] = useTranslation("common");


  const selectAreaCode = (
    <Form.Item
      noStyle
      name="countryId"
      initialValue={settings} // Provide the initial value if available
    >
      <Select
        showSearch={true}
        optionFilterProp="label"
        style={{ width: 100, background: "white" }}
        options={formatedCountry}
      />
    </Form.Item>
  );

  const [errors, setErrors] = useState<ErrorsType>({
    email: undefined,
  });

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)) {
      setErrors({
        email: undefined,
      });
    } else {
      setErrors({
        email: "Email is not valid",
      });
    }
  };
  const [, setExchangeRate] = useState("");
  const [, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (e: any) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/; // Updated regular expression
    if (regex.test(value)) {
      setExchangeRate(value);
      setErrorMessage("");
    } else {
      setErrorMessage("Please enter numbers only"); // Updated error message
    }
  };

  const handlePhoneNumberKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /[0-9.]|\./;

    if (!regex.test(keyValue)) {
      e.preventDefault();
    }

    if (keyValue === "." && e.target.value.indexOf(".") !== -1) {
      e.preventDefault();
    }
    if (keyValue === "." && e.target.selectionStart === 0) {
      e.preventDefault();
    }
  };
  return (
    <Row>
      <Col span={6}>
        <Form.Item
          name="companyname"
          label={`${t("company-name")}`}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input
            autoComplete="off"
            placeholder={`${t("enter-company-name")}`}
            data-testid="name"
          />
        </Form.Item>


        <Form.Item
          name="phone"
          label={`${t("primary-number")}`}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input
            addonBefore={selectAreaCode}
            maxLength={20}
            autoComplete="off"
            onKeyPress={handlePhoneNumberKeyPress}
            placeholder="000 000 000"
          />
        </Form.Item>
        <Form.Item
          name="mobile"
          label={`${t("secondary-number")}`}

        >
          <Input
            addonBefore={selectAreaCode}
            maxLength={10}
            autoComplete="off"
            placeholder="000 000 000"
            onChange={handlePhoneNumberChange}
            onKeyPress={handlePhoneNumberKeyPress}
            data-testid="phone-input"
          />
        </Form.Item>



        <Form.Item
          name="email"
          label={`${t("email")}`}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input
            autoComplete="off"
            placeholder={`${t("enter-your-company-email")}`}
            data-testid="email-input"
            onChange={handleEmailChange}
          />
        </Form.Item>
        {errors.email && <span>{errors.email}</span>}
      </Col>
      <Col span={6} offset={3}>
        <Form.Item
          name="companylogo"
          label={`${t("company-logo")}`}

        >
          <CostumeUpload />
        </Form.Item>
      </Col>
    </Row>
  );
};
export default Company;
